import { DefaultLayout as Layout } from '../../../layouts/Default/DefaultLayout';
import { SystemCodeSearch } from '../SystemCodeSearch/SystemCodeSearch';

export const SystemCodesManagerPage = () => {
  return (
    <Layout>
      <h1 id="primaryPageTitle" className="d-inline">
        Codes Maintenance
      </h1>
      <SystemCodeSearch />
    </Layout>
  );
};
